import { Component } from "react";

import { classNames } from "@helpers/css";

type SkillItem = {
  name: string;
  description: string;
};

type Props = {
  items: SkillItem[];
  command: (props: { id: string }) => void;
};

type State = {
  selectedIndex: number;
};

export default class SkillCommandsList extends Component<Props, State> {
  state: State = {
    selectedIndex: 0,
  };

  componentDidUpdate(oldProps: Props) {
    if (this.props.items !== oldProps.items) {
      this.setState({ selectedIndex: 0 });
    }
  }

  onKeyDown({ event }: { event: KeyboardEvent }) {
    if (event.key === "ArrowUp") {
      this.upHandler();
      return true;
    }
    if (event.key === "ArrowDown") {
      this.downHandler();
      return true;
    }
    if (event.key === "Enter") {
      if (this.props.items.length > 0) {
        this.enterHandler();
        return true;
      }
      return false;
    }
    if (event.key === "Tab") {
      if (this.props.items.length > 0) {
        this.enterHandler();
        return true;
      }
      return false;
    }
    return false;
  }

  upHandler() {
    const newIndex = this.state.selectedIndex - 1;
    if (newIndex >= 0) {
      this.setState({ selectedIndex: newIndex });
    }
  }

  downHandler() {
    const newIndex = this.state.selectedIndex + 1;
    if (newIndex < this.props.items.length) {
      this.setState({ selectedIndex: newIndex });
    }
  }

  enterHandler() {
    this.selectItem(this.state.selectedIndex);
  }

  selectItem(index: number) {
    const item = this.props.items[index];
    if (item) {
      this.props.command({ id: item.name });
    }
  }

  render() {
    const { items } = this.props;
    if (items.length === 0) return null;

    return (
      <div
        className="relative rounded bg-white border text-sm shadow overflow-y-auto max-h-72"
        aria-label="ask-ai-skill-commands"
        role="listbox"
      >
        {items.map((item, index) => (
          <button
            type="button"
            role="option"
            aria-selected={index === this.state.selectedIndex}
            className={classNames(
              "block w-72 text-left px-3 py-2 border-b last:border-b-0 hover:bg-gray-50 text-sm",
              index === this.state.selectedIndex && "bg-gray-100",
            )}
            key={item.name}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.selectItem(index);
            }}
          >
            <span className="font-mono text-xs font-medium text-blue-link">
              <span aria-hidden="true">/</span>
              <span>{item.name}</span>
            </span>
            <span className="block text-gray-400 text-xs mt-0.5">
              {item.description}
            </span>
          </button>
        ))}
      </div>
    );
  }
}
